// https://vuex.vuejs.org/en/mutations.html

export default {
  setDrawer: (state, payload) => {
    state["drawer"] = payload;
  },
  toggleDrawer: state => {
    state["drawer"] = !state["drawer"];
  },
  setRoutes: (state, payload) => {
    state["routeList"] = payload;
  },
  setConfig: (state, payload) => {
    state["config"] = payload;
  }
};
